<mat-form-field>
    <mat-label>{{label | translate}}</mat-label>
    <input matInput [(ngModel)]="object[lang]" (change)="setValue()">
</mat-form-field>